import { createCspViolationReporter } from '@/service/csp/createCspViolationReporter';

angular.module('inspinia').factory('cspViolationReportService', function () {
  return {
    start: createCspViolationReporter(document, window.browserLogger),
  };
});
